import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { RangeAccessNotice } from './RangeAccessNotice';
import { CalendarEmbed } from './CalendarEmbed';
import { QuickLinks } from './QuickLinks';
export function CalendarPage() {
  return <PageLayout data-id="element-473">
      <HeaderBanner data-id="element-474" />
      <RangeAccessNotice data-id="element-475" />
      <CalendarEmbed data-id="element-476" />
      <QuickLinks data-id="element-477" />
    </PageLayout>;
}